import { FormFieldT } from "../../models/models";
import * as yup from "yup";
import { yupValidations } from "./yupValidations";

/**
 * Gets array of form fields and builds a Yup schema
 * */

export const getValidationSchemaFromFields = (fields: FormFieldT[], t: any) => {
  // yup validation schema
  const schemaData: any = {};

  // get validation for each field if exists
  for (let field of fields) {
    // check if the field has validation requirements
    if (field.validation) {
      // check
      if (typeof field.validation === "string") {
        schemaData[getFieldName(field.name, field.label)] = (
          yupValidations(t) as any
        )[field.validation];
      } else {
        schemaData[getFieldName(field.name, field.label)] = field.validation;
      }
    }
  }

  // define schema with found fields
  const schema = yup.object(schemaData).required();

  return schema;
};

/**
 * Get valid field name from field label
 * */

export const getFieldName = (
  name: string | undefined,
  label: string | undefined
) => {
  // check if name already defined
  if (name) return name;

  // check if parameter exist
  if (!label)
    throw new Error("You have to define at least one parameter, label or name");

  return camelize(label);
};

/**
 * Get camelCase string from any string
 * */

export const camelize = (string: string) => {
  return string
    .replace(/(?:^\w|[A-Z]|\b\w|\s+)/g, function (match, index) {
      if (+match === 0) return ""; // or if (/\s+/.test(match)) for white spaces

      return index === 0 ? match.toLowerCase() : match.toUpperCase();
    })
    .replace(/[^\w]/g, "");
};

export const getUploadedImageFromFileSize = (file: File): Promise<[number, number]> => {
  return new Promise((resolve, reject) => {
    if (!file) {
      reject("No file provided");
    }

    const image = new Image();

    image.onload = () => {
      resolve([image.width, image.height]);
    };

    image.onerror = () => {
      reject("Error loading image");
    };

    const objectURL = URL.createObjectURL(file);
    image.src = objectURL;
  });
};
